<template>
  <div>
    <van-row class="info-item" v-for="(detail) in detailList" :key="detail.field">
      <van-col span="8" class="label">
        {{detail.label}}
      </van-col>
      <van-col span="16" class="value">
        {{detail.render ? detail.render(detailData[detail.field]) : detailData[detail.field]}}
      </van-col>
      <i v-if="showCopy&&detailData[detail.field]" class="iconfont" @click="() => copyInfo(detailData[detail.field])">&#xe6cb;</i>
    </van-row>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Notify
} from 'vant'

export default {
  name: 'detailForm',
  props: {
    detailList: {
      type: Array
    },
    detailData: {
      type: Object
    },
    showCopy: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    copyInfo (text) {
      let textArea = document.createElement('textarea')
      textArea.style.position = 'fixed'
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.width = '2em'
      textArea.style.height = '2em'
      textArea.style.padding = '0'
      textArea.style.border = 'none'
      textArea.style.outline = 'none'
      textArea.style.boxShadow = 'none'
      textArea.style.background = 'transparent'
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      try {
        let successful = document.execCommand('copy')
        if (successful) {
          Notify({ type: 'success', message: '文本已经复制到剪贴板' })
        } else {
          Notify({ type: 'danger', message: '您的浏览器不支持一键复制，请自行选中文字复制' })
        }
      } catch (err) {
        Notify({ type: 'danger', message: '您的浏览器不支持一键复制，请自行选中文字复制' })
      }
      document.body.removeChild(textArea)
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col
  }
}
</script>

<style lang="less" scoped>

  .info-item {
    border-bottom: solid 1Px #edf2f6;
    padding: 25px 30px;
    background-color: #fff;
    position: relative;
  }

  .label{
    width: 200px;
    font-size:28px;
    line-height: 40px;
    color:#999;
  }

  .value {
    font-size:28px;
    line-height: 40px;
    color:#333;
  }
  .iconfont {
    position: absolute;
    font-size: 28px;
    right: 0;
    color: #2372FF;
    top: 45px;
    right: 30px;
  }

</style>
